export const EXCEL_FONT = {
  MS_GOTHIC: 'ＭＳ ゴシック',
  MS_MINCHO: 'ＭＳ 明朝',
  MS_P_GOTHIC: 'ＭＳ Ｐゴシック',
  MS_P_MINCHO: 'ＭＳ Ｐ明朝',
};
